import { faker } from '@faker-js/faker';

import { UserRole } from '../../constants/user-role';
import redux from '../../redux';

describe('redux slice: banner', () => {
  it('should support the set customer service url method', () => {
    const url = faker.internet.url();
    expect(
      redux.store.dispatch(redux.api.setCustomerServiceUrl(url)),
    ).toStrictEqual({
      payload: url,
      type: 'api/setCustomerServiceUrl',
    });
  });

  it('should support the set context method', () => {
    const context = {
      customer_group_uuid: faker.string.uuid(),
      customer_uuid: faker.string.uuid(),
      enforce: 'customer_group',
      role: UserRole.USER,
    };

    expect(redux.store.dispatch(redux.api.setContext(context))).toStrictEqual({
      payload: context,
      type: 'api/setContext',
    });
  });
});
